import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import styles from './index.module.scss.js';

const Divider = ({ as = 'hr', orientation = 'horizontal', type = 'full', flexItem, ...props }) => {
    const Component = as;
    return (jsx(Component, { className: classNames(styles.divider, styles[`divider__${orientation}`], styles[`divider__${type}`], flexItem && styles.divider__flexItem), ...props }));
};

export { Divider };
